var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.5 8a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-4.553-2.816a.833.833 0 0 1 0 1.179l-1.77 1.77L10.946 9.9a.834.834 0 0 1-1.178 1.178L7.999 9.311l-1.768 1.768a.833.833 0 0 1-1.179-1.178l1.769-1.769-1.768-1.767a.833.833 0 0 1 1.179-1.179l1.767 1.768 1.77-1.77a.833.833 0 0 1 1.178 0",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorFilled);
export default ForwardRef;